import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/animate.css';
import './css/font-awesome.min.css';
import './css/index.css';
import './css/leaflet.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js